import React, { useState } from 'react';
import styles from '../../styles/components/question-reorder/QuestionReorder.module.css';
import { ActionButton } from '@ax2/common/components/ActionButton';
import {
  useSurveyContext,
  useSurveyDispatchContext,
} from '../../contexts/SurveyContext';
import DragList from '../drag-and-drop/DragList';
import QuestionSchema from '@ax2/common/model/schemas/QuestionSchema';
import { fixOrder } from '@ax2/common/helpers/array';
import { getTemplateText } from '@ax2/common/helpers/template';
import ScreenerQuestionSchema from '@ax2/common/model/schemas/ScreenerQuestionSchema';
import parse from 'html-react-parser';

export interface QuestionReorderProps {
  isScreener: boolean | undefined;
  onComplete?: () => void;
}

const QuestionReorder: React.FC<QuestionReorderProps> = ({
  onComplete,
  isScreener,
}) => {
  const surveySchema = useSurveyContext();
  const surveyDispatch = useSurveyDispatchContext();
  const [questions, setQuestions] = useState<
    (QuestionSchema | ScreenerQuestionSchema)[]
  >(
    surveySchema
      ? isScreener
        ? surveySchema.screeners
        : surveySchema.questions
      : []
  );
  const orderLabel = isScreener ? 'S' : 'Q';
  return (
    surveySchema && (
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.title}>Reorder Questions</div>
          <div className={styles.subTitle}>
            Drag and move each question to reorder. Click the Save Reorder
            button when you are finished.
          </div>
        </div>
        <div className={styles.content}>
          <DragList
            cards={questions.map(question => {
              return {
                orderControl: (order: number) => `${orderLabel}-` + (order + 1),
                itemControl:
                  'content' in question
                    ? (parse(getTemplateText(question.content)) as string)
                    : '',
                itemFrame: 'shadow',
                item: question,
              };
            })}
            onComplete={cards =>
              setQuestions(fixOrder(cards.map(c => c.item as QuestionSchema)))
            }
          />
        </div>
        <div className={styles.footer}>
          <ActionButton
            text="Save Reorder"
            type="primary"
            onClick={() => {
              surveyDispatch(
                isScreener
                  ? {
                      type: 'screeners',
                      screeners: questions as ScreenerQuestionSchema[],
                    }
                  : {
                      type: 'questions',
                      questions: questions as QuestionSchema[],
                    }
              );
              onComplete && onComplete();
            }}
          />
        </div>
      </div>
    )
  );
};

export default QuestionReorder;
